module.exports = __webpack_public_path__ + "media/icons/widget-download_app_store_black-fa017a3c.png";